// Shown INSTEAD of the app when the session in this browser belongs to an account this app does not
// hold (for example an account whose Dosen record is gone, or one that exists at the identity
// provider only). The session itself is fine, so nothing is ended behind the person's back: they
// sign in with another account (which replaces the session) or ask for an invitation.
import React from 'react';
import DosenButton from '../../components/ui/Buttons/DosenButton';
import { rememberAuthConfig } from '../../auth/authMode';
import { decodeJwt, leaveTo, readTokens, signOut } from '../../auth/session';
import AuthShell from './AuthShell';
import { Notice } from './fields';

const NotSetUpHerePage: React.FC = () => {
  const tokens = readTokens();
  const email = String(decodeJwt(tokens?.id_token).email ?? '');

  const useAnotherAccount = () => {
    signOut(tokens?.refresh_token, tokens?.region);
    rememberAuthConfig();
    leaveTo(`${window.location.origin}/#/login`);
  };

  return (
    <AuthShell title="This account isn't set up here">
      <Notice tone="info" focus>
        {email ? (
          <>
            You are signed in as <strong>{email}</strong>, and that account
          </>
        ) : (
          'The account you are signed in with'
        )}{' '}
        is not set up in Dosen. Sign in with a different account, or ask your organization's administrator for an
        invitation.
      </Notice>
      <DosenButton fullWidth sizeVariant="lg" onClick={useAnotherAccount}>
        Sign in with a different account
      </DosenButton>
    </AuthShell>
  );
};

export default NotSetUpHerePage;
